import React from 'react';

import Skel from '../skel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import * as fmt from '../../utils/fmt';
import styles from './styles.css';

const COLOR_LABEL = '#8B8B8D';

const STATUS_STYLES = {
  'conforme': {
    background: '#DCFCE7',
    color: '#016630',
    border: '1px solid #DCFCE7',
  },
  'realizando consulta...': {
    background: '#93c5fd',
    color: '#1e40af',
    border: '1px solid #93c5fd',
  },
  'default': {
    background: '#f3f4f6',
    color: '#374151',
    border: '1px solid #d1d5db',
  },
};

const StatusBadge = ({ description }) => {
  if (!description) return <span>-</span>;
  const key = description.toLowerCase().trim();
  const style = STATUS_STYLES[key] || STATUS_STYLES.default;

  return (
    <span
      style={{
        ...style,
        padding: '2px 10px',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: 'bold',
        display: 'inline-block',
        letterSpacing: '0.05em',
      }}
    >
      {description[0].toUpperCase() + description.slice(1).toLowerCase()}

    </span>
  );
};

const LabelSubtitle = withStyles({
  root: {
    color: COLOR_LABEL,
    textTransform: 'uppercase',
    fontSize: '12px',
  }
})(Typography);

const LabelText = withStyles({
  root: { color: '#8B8B8D', fontSize: '14px' }
})(Typography);

export default function NewQueryDetails({ query = {} }) {
  const loading = !(query && query.id);

  return <>
  
<div style={{
  display: 'flex', flexDirection: 'column',
  padding: '0rem 5px', marginBottom: '16px', marginTop: '16px',
}}>
  <div className={styles.queryStatusRow} style={{ display: 'flex', gap: '24px' }}>
    <div style={{ display: 'flex', gap: '5px' }}>
      <LabelText className={{ fontSize: '10px' }}>SITUAÇÃO:</LabelText>
      <StatusBadge description={query.status && query.status.description} />
    </div>

    <div style={{ display: 'flex', gap: '5px', fontWeight: 'bold' }}>
      <LabelText className={{ fontSize: '10px' }}>USUÁRIO:</LabelText>
      <Skel loading={loading} >{query.user && query.user.login}</Skel>
    </div>
  </div>
</div>
    <Grid
      spacing={24}
      container
      style={{ fontSize: '14px', fontWeight: 'bold', padding: '0rem 5px' }}
    >
      
      <Grid item md={1} sm={2}>
        <div>
          <LabelSubtitle variant="subtitle2">
            Código
          </LabelSubtitle>

          <Skel loading={loading}>{query.id || '-'}</Skel>
        </div>
      </Grid>

      <Grid item md={1} sm={2}>
        <div>
          <LabelSubtitle variant="subtitle2">
            Tipo
          </LabelSubtitle>

          <Skel loading={loading}>{(query.type && query.type.description) || '-'}</Skel>
        </div>
      </Grid>

      <Grid item md={10} sm={8}>
        <div>
          <LabelSubtitle variant="subtitle2">
            Data Envio
          </LabelSubtitle>

          <Skel loading={loading}>{fmt.isoDate(query.sentDate) || '-'}</Skel>
        </div>
      </Grid>

      <Grid item md={2} sm={3}>
        <div>
          <LabelSubtitle variant="subtitle2">
            Data de Recebimento
          </LabelSubtitle>

          <Skel loading={loading}>{fmt.isoDate(query.receivingDate)}</Skel>
        </div>
      </Grid>

      {
        query.daysUntilDue &&
          <Grid item md={2} sm={3}>
            <div>
              <LabelSubtitle variant="subtitle2">
                Dias Vencimento
              </LabelSubtitle>

              <Skel loading={loading}>{query.daysUntilDue}</Skel>
            </div>
          </Grid>
      }

      {
        query.limitDate &&
          <Grid item md={2} sm={3}>
            <div>
              <LabelSubtitle variant="subtitle2">
                Data Vencimento
              </LabelSubtitle>

              <Skel loading={loading}>{fmt.isoDate(query.limitDate)}</Skel>
            </div>
          </Grid>
      }

    </Grid>
  </>;
}
